<template>
    <div class="py-4 container-fluid">
      <div class=" row">
        <div class="col-12">
          <ClientsTable :clients="products"/>
        </div>
      </div>
      
    </div>
</template>
  
<script>
import axios from "axios";
import ClientsTable from "./components/Table.vue";  
export default {
    name: "tables",
    components: {
        ClientsTable,
    },
    data() {
        return {
            products:[],
        };
    },
    methods:{
        async fetchProducts(config){
            let self=this;
            axios.get(this.$store.state.apiURL+'list/products?recperpage=all',config)
            .then((result)=>{
                console.log(result);
                this.products=result.data.products;
                // Asegúrate de que los clientes ya han sido cargados
                
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        }
    },
    mounted() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchProducts(config);
    },
};
</script>
  